module.exports = __webpack_public_path__ + "img/middle_12.fd2f33e0.png";